<template>
  <div class="home">
    <div class="main">
      <div class="container">
        <div class="section1 clearf">
          <div class="tea-brief">
            <div class="section-title section-title1">
              <img src="@/assets/iconfont1.png" style="width:20px;" />
              <span>安化农技服务</span>
            </div>
            <p>
              安化县，是湖南省面积第三大的县，山地面积达82%，是典型的山区县、库区县。同时安化也是是湖南有名的林业资源大县，茶叶生产大县，药材产业大县。特色产业稳步发展，突出“一村一品”示范引领，获评中国“十三五”茶产业发展十强县。主要农产品有稻谷、玉米、油料、茶叶、水果、蔬菜、猪、牛、羊等出笼家禽。农业技术在当地也应运而生，因为农业科技是农业发展的第一推动力。特别是改革开放以来，中国农业取得了长足的发展，其中农业科技发挥了巨大作用，为了加强农业技术推广工作，促使农业科研成果和实用技术尽快应用于农业生产，保障农业的发展，实现农业现代化，特提供农业技术管理平台，相关资料供大家查阅、参考。
            </p>
          </div>
          <div class="swiper-box">
            <el-carousel height="390px" arrow="never">
              <el-carousel-item>
                <a
                  href="https://zx.ahnydsj.com/front/index/finance"
                  target="_blank"
                  ><img src="@/assets/banner3.jpg" alt=""
                /></a>
              </el-carousel-item>
              <el-carousel-item>
                <img src="@/assets/banner2.jpg" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="section2">
          <div class="section-title clearf">
            <img src="@/assets/iconfont2.png" />
            <span>农业资讯</span>
            <router-link :to="{ path: '/information' }" class="baseColor"
              >更多 ></router-link
            >
          </div>
          <div class="brief-news clearf">
            <div class="brief-img">
              <el-carousel
                trigger="click"
                height="220px"
                indicator-position="outside"
                v-if="secondFlag"
              >
                <el-carousel-item v-for="(item, key) in smallBo" :key="key">
                  <router-link
                    :to="{
                      path: '/informationDetail',
                      query: { tid: item.tid }
                    }"
                  >
                    <img :src="$img + item.url" />
                  </router-link>
                </el-carousel-item>
              </el-carousel>
              <img v-else src="@/assets/banner1.jpg" />
            </div>
            <div class="brief-list">
              <ul>
                <li v-for="(item, index) in briefNews" :key="index">
                  <router-link
                    :to="{
                      path: '/informationDetail',
                      query: { tid: item.tid }
                    }"
                    >{{ item.title }}</router-link
                  >
                  <span class="time">{{ item.publishDate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section3 clearf">
          <div class="section-title">
            <img src="@/assets/iconfont3.png" style="height:28px;" />
            <span>农业百科</span>
            <router-link :to="{ path: '/encyclopedias' }" class="baseColor"
              >更多 ></router-link
            >
          </div>
          <div class="left">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="农业气象" name="first">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="农业政策" name="second">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="市场行情" name="third">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="right">
            <el-tabs v-model="activeName2" @tab-click="handleClick2">
              <el-tab-pane label="实用技术" name="first">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias2"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="防灾减灾" name="second">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias2"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="病虫治理" name="third">
                <ul>
                  <li
                    class="clearf"
                    v-for="(item, index) in Encyclopedias2"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/WikiDetails', query: { tid: item.tid } }"
                      >{{ item.title }}</router-link
                    >
                    <span class="time">{{ item.publishDate }}</span>
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="section4">
          <div class="section-title">
            <img src="@/assets/iconfont4.png" />
            <span>农技课堂</span>
            <router-link :to="{ path: '/classroom' }" class="baseColor"
              >更多 ></router-link
            >
          </div>
          <div class="classroom">
            <ul class="clearf">
              <li
                class="classroom-item"
                v-for="(item, index) in classList"
                :key="index"
              >
                <router-link
                  :to="{ path: '/classroomDetail', query: { tid: item.tid } }"
                >
                  <img
                    v-if="item.coverUrl"
                    class="item-bg"
                    :src="$img + item.coverUrl"
                  />
                  <img v-else class="item-bg" src="@/assets/vidoeDefault.jpg" />
                  <img class="play" src="@/assets/play.png" />
                  <div class="item-bottom">
                    <div class="classroom-title">{{ item.title }}</div>
                    <div class="classroom-time">
                      <span class="left">{{ item.publishDate }}</span>
                      <span class="right" style="font-size:12px;">{{
                        "阅读量:" + item.readingQuantity
                      }}</span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="section5 clearf">
          <div class="expert">
            <div class="section-title">
              <img
                src="@/assets/iconfont5.png"
                style="width:27px;height:27px;"
              />
              <span>农技专家</span>
              <router-link :to="{ path: '/expert' }" class="baseColor"
                >更多 ></router-link
              >
            </div>
            <div class="expert-info clearf">
              <div class="expert-introduce" ref="expertIntroduce">
                <el-carousel :interval="4000" height="200px" trigger="click">
                  <el-carousel-item
                    v-for="(item, index) in ExpertList"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/expertDetail', query: { tid: item.tid } }"
                    >
                      <div class="expert-big">
                        <div class="head-big">
                          <img
                            v-if="item.coverUrl"
                            :src="$img + item.coverUrl"
                            style="border-radius:50%;"
                          />
                          <img
                            v-else
                            src="../assets/expert-big.png"
                            style="border-radius:50%;"
                          />
                        </div>
                        <div class="big-name">
                          <span>{{ item.realname }}</span>
                          <span>{{ item.jobTitle }}</span>
                        </div>
                        <div class="education">
                          <div
                            v-for="(item1, index) in educationList"
                            :key="index"
                            v-show="item1.tid === item.education"
                          >
                            <span v-if="item1.dataName">学历</span>
                            <span>{{ item1.dataName }}</span>
                          </div>
                        </div>
                        <div class="achievement">{{ item.introduction }}</div>
                      </div>
                    </router-link>
                  </el-carousel-item>
                </el-carousel>

                <div class="expert-list clearf" ref="expertLlist">
                  <div
                    class="list-item clearf"
                    v-for="(item, index) in ExpertList"
                    :key="index"
                    ref="list-item"
                  >
                    <router-link
                      :to="{ path: '/expertDetail', query: { tid: item.tid } }"
                    >
                      <div class="small-head">
                        <img
                          v-if="item.coverUrl"
                          :src="$img + item.coverUrl"
                          style="border-radius:50%;"
                        />
                        <img
                          v-else
                          src="../assets/expert-small.png"
                          style="border-radius:50%;"
                        />
                      </div>
                      <div class="small-right">
                        <p>
                          <span>{{ item.realname }}</span>
                          <span>{{ item.jobTitle }}</span>
                        </p>
                        <p
                          v-for="(item1, index) in educationList"
                          :key="index"
                          v-show="item1.tid === item.education"
                        >
                          <span v-if="item1.dataName">学历:</span>
                          <span>{{ item1.dataName }}</span>
                        </p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="function-box">
            <router-link :to="{ path: '/questiontList' }">
              <img src="@/assets/function1.png" />
            </router-link>
            <router-link
              :to="{ path: '/encyclopedias', query: { second: 'second' } }"
            >
              <img src="@/assets/function2.png" />
            </router-link>
            <router-link :to="{ path: '/teaCulture' }">
              <img src="@/assets/function4.png" />
            </router-link>
          </div>
        </div>
        <div class="section6 clearf">
          <div class="home-hotline">
            <img src="@/assets/question.jpg" />
            <router-link :to="{ path: '/hotline' }" class="question"
              >我要提问</router-link
            >
          </div>
          <div class="problem-list">
            <router-link :to="{ path: '/questiontList' }" class="baseColor more"
              >更多 ></router-link
            >
            <el-tabs v-model="activeName3" @tab-click="handleClick3">
              <el-tab-pane label="技术类" name="first">
                <ul class="clearf">
                  <li
                    class="problem-item"
                    v-for="(item, index) in QuestionList"
                    :key="index"
                  >
                    <router-link
                      :to="{
                        path: '/questionDetails',
                        query: { tid: item.tid }
                      }"
                      >{{ item.title }}</router-link
                    >
                    <p>
                      <span class="left">发布者：{{ item.publishByName }}</span>
                      <span>{{ item.publishDate | formatDate }}</span>
                    </p>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="政策类" name="second">
                <ul class="clearf">
                  <li
                    class="problem-item"
                    v-for="(item, index) in QuestionList"
                    :key="index"
                  >
                    <router-link
                      :to="{
                        path: '/questionDetails',
                        query: { tid: item.tid }
                      }"
                      >{{ item.title }}</router-link
                    >
                    <p>
                      <span class="left">发布者：{{ item.publishByName }}</span>
                      <span>{{ item.publishDate | formatDate }}</span>
                    </p>
                  </li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="市场类" name="third">
                <ul class="clearf">
                  <li
                    class="problem-item"
                    v-for="(item, index) in QuestionList"
                    :key="index"
                  >
                    <router-link
                      :to="{
                        path: '/questionDetails',
                        query: { tid: item.tid }
                      }"
                      >{{ item.title }}</router-link
                    >
                    <p>
                      <span class="left">发布者：{{ item.publishByName }}</span>
                      <span>{{ item.publishDate | formatDate }}</span>
                    </p>
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defalutImg: "@/assets/briefDeafault.jpg",
      activeName: "first",
      activeName2: "first",
      activeName3: "first",
      category1: "e6d895f9d2aa11e9bddcda211f4fee1e",
      category2: "19b08a4ad2ab11e9bddcda211f4fee1e",
      category3: "4b6edd40d2ab11e9bddcda211f4fee1e",
      briefNews: [],
      briefNews2: [],
      briefImg: [],
      Encyclopedias: [],
      Encyclopedias2: [],
      agriculturalPolicy: [],
      classList: [],
      ExpertList: [],
      ExpertBig: [],
      educationList: [],
      QuestionList: [],
      secondFlag: false,
      smallBo: []
    };
  },
  created() {
    this.getBriefnews();
    this.getEncyclopedias(this.category1);
    this.getEncyclopedias2(this.category2);
    this.getClass();
    this.getExpert();
    this.queryDataDictInfo();
    this.getHotline(this.category3);
  },
  mounted() {
    this.handlescroll();
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;
    }
  },
  methods: {
    //小专家滚动
    handlescroll() {
      var box = this.$refs.expertLlist,
        show = this.$refs.expertIntroduce,
        keyid,
        step = 4,
        left;
      // left = box.offsetLeft - show.previousElementSibling.offsetWidth;
      left = box.offsetLeft;
      function getshow() {
        if (keyid) clearInterval(keyid);
        keyid = setInterval(function() {
          step = document.body.offsetWidth <= 2400 ? 1 : 2;
          left -= step;
          if (Math.abs(left) >= box.scrollWidth - show.offsetWidth) {
            left = 0;
          }
          box.style.left = left + "px";
        }, 20);
      }
      getshow();
      show.addEventListener("mouseover", function() {
        clearInterval(keyid);
      });
      show.addEventListener("mouseout", function() {
        getshow();
      });
    },
    handleClick(tab, event) {
      let category;
      if (tab.name == "first") {
        category = "e6d895f9d2aa11e9bddcda211f4fee1e";
        this.getEncyclopedias(category);
      } else if (tab.name == "second") {
        category = "f96d6cb1d2aa11e9bddcda211f4fee1e";
        this.getEncyclopedias(category);
      } else {
        category = "08f0b894d2ab11e9bddcda211f4fee1e";
        this.getEncyclopedias(category);
      }
    },
    handleClick2(tab, event) {
      let category;
      if (tab.name == "first") {
        category = "19b08a4ad2ab11e9bddcda211f4fee1e";
        this.getEncyclopedias2(category);
      } else if (tab.name == "second") {
        category = "23da9d56d2ab11e9bddcda211f4fee1e";
        this.getEncyclopedias2(category);
      } else {
        category = "2f1a09c4d2ab11e9bddcda211f4fee1e";
        this.getEncyclopedias2(category);
      }
    },
    handleClick3(tab, event) {
      let category;
      if (tab.name == "first") {
        category = "4b6edd40d2ab11e9bddcda211f4fee1e";
        this.getHotline(category);
      } else if (tab.name == "second") {
        category = "5aae1135d2ab11e9bddcda211f4fee1e";
        this.getHotline(category);
      } else {
        category = "6868bab8d2ab11e9bddcda211f4fee1e";
        this.getHotline(category);
      }
    },

    // 首页简讯列表
    getBriefnews() {
      this.$axios({
        method: "get",
        url: "/zs/news/newsList",
        params: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(res => {
        let briefData = JSON.parse(res.data).respData.content || [];
        let arr = [];
        for (let index = 0; index < briefData.length; index++) {
          const element = briefData[index];
          let mapValue = {};
          if (
            element.coverUrl == "" ||
            element.coverUrl == undefined ||
            element.coverUrl == "undefined"
          ) {
          } else {
            mapValue = {
              url: element.coverUrl,
              tid: element.tid
            };
            arr.push(mapValue);
            this.secondFlag = true;
          }
        }
        this.smallBo = arr;
        if (this.smallBo.length <= 0) {
          this.secondFlag = false;
        }
        this.briefNews = briefData;
      });
    },
    //首页百科农业气象列表左
    getEncyclopedias(category) {
      this.$axios({
        method: "get",
        url: "/zs/wiki/wikiList",
        params: {
          category: category,
          pageNum: 1,
          pageSize: 6
        }
      }).then(res => {
        let EncyclopediasData = JSON.parse(res.data).respData.content;
        this.Encyclopedias = EncyclopediasData;
      });
    },
    //首页百科农业气象列表右
    getEncyclopedias2(category) {
      this.$axios({
        method: "get",
        url: "/zs/wiki/wikiList",
        params: {
          category: category,
          pageNum: 1,
          pageSize: 6
        }
      }).then(res => {
        let EncyclopediasData2 = JSON.parse(res.data).respData.content;
        this.Encyclopedias2 = EncyclopediasData2;
      });
    },
    //首页课堂列表
    getClass() {
      this.$axios({
        methods: "get",
        url: "/zs/farmingCourse/queryFarmingCoursePage",
        params: {
          pageNum: 1,
          pageSize: 8
        }
      }).then(res => {
        let classData = JSON.parse(res.data).respData.content;
        this.classList = classData;
      });
    },
    //首页农技专家
    getExpert() {
      this.$axios({
        method: "get",
        url: "/zs/farmingExpert/queryFarmingExpertPage",
        params: {
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        let ExpertData = JSON.parse(res.data).respData.content;
        this.ExpertList = ExpertData;
      });
    },
    // 首页农技专家数据字典
    queryDataDictInfo() {
      this.$axios({
        method: "get",
        url: "/zs/common/queryDataDict",
        params: {
          dictTypeCode: "expert_education"
        }
      }).then(res => {
        this.educationList = JSON.parse(res.data).respData;
        // console.log(this.educationList);
      });
    },
    //首页热线问答
    getHotline(category) {
      this.$axios({
        method: "get",
        url: "/zs/question/queryWebQuestionPage",
        params: {
          category: category,
          pageNum: 1,
          pageSize: 8
        }
      }).then(res => {
        let QuestionData = JSON.parse(res.data).respData.content;
        this.QuestionList = QuestionData;
      });
    }
  }
};
</script>

<style lang="less">
.baseColor {
  color: #149508;
}
.time {
  color: #999;
}
.section-title {
  height: 35px;
  line-height: 28px;
  margin-bottom: 5px;
  img {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    margin-bottom: 3px;
  }
  span {
    font-size: 20px;
    color: #333;
    font-weight: 700;
  }
  a {
    float: right;
    font-size: 14px;
  }
}
.section-title1 {
  margin-bottom: 0;
}
.main {
  .section1 {
    margin-top: 20px;
    .tea-brief {
      float: left;
      width: 406px;
      background-color: #fff;
      padding: 12px 19px;
      height: 390px;
      p {
        color: #666;
        line-height: 25px;
      }
      .brief-tip {
        padding: 5px 0;
      }
    }
    .swiper-box {
      float: right;
      width: 770px;
      height: 390px;
    }
  }
  .section2 {
    padding: 10px 15px;
    margin-top: 20px;
    background-color: #fff;
    .brief-news {
      padding: 20px 0 10px 0;
      border-top: 1px solid #e4e4e4;
      .brief-img {
        float: left;
        width: 356px;
        height: 220px;
      }
      .brief-list {
        float: right;
        width: 760px;
        li {
          list-style: disc;
          color: #149508;
          height: 44px;
          line-height: 44px;
          a {
            float: left;
            color: #333;
            width: 650px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              color: #149508;
            }
          }
          span {
            float: right;
          }
        }
      }
    }
  }
  .section3 {
    padding: 15px;
    margin-top: 20px;
    background-color: #fff;
    .left {
      float: left;
      width: 45%;
    }
    .right {
      float: right;
      width: 45%;
    }
    li {
      line-height: 37px;
      a {
        float: left;
        color: #333;
        width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: #149508;
        }
      }
      span {
        float: right;
      }
    }
  }
  .section4 {
    padding: 15px;
    margin-top: 20px;
    background-color: #fff;
    .classroom {
      .classroom-item {
        float: left;
        width: 25%;
        padding: 10px;
        a {
          position: relative;
          display: block;
          width: 100%;
          height: 100%;
          .item-bg {
            height: 167px;
          }
          .play {
            position: absolute;
            left: 50%;
            top: 60px;
            margin-left: -23px;
            width: 47px;
            height: 47px;
          }
          .item-bottom {
            box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
            padding: 10px;
            .classroom-title {
              color: #333;
              font-size: 18px;
              padding: 10px 0;
              height: 44px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .classroom-time {
              font-size: 14px;
              color: #666;
              line-height: 20px;
              height: 20px;
              .left {
                float: left;
              }
              .right {
                float: right;
              }
            }
          }
        }
      }
    }
  }
  .section5 {
    margin-top: 20px;
    .expert {
      float: left;
      width: 882px;
      height: 392px;
      padding: 20px;
      background-color: #fff;
      overflow: hidden;
      .head-big {
        float: left;
        width: 105px;
        height: 200px;
        margin-right: 40px;
        img {
          width: 105px;
          height: 105px;
        }
      }
      .expert-introduce {
        position: relative;
        height: 280px;
        overflow: hidden;
        :hover {
          cursor: pointer;
          button {
            display: none;
          }
        }
        .big-name {
          font-size: 18px;
          color: #333;
          span {
            margin-right: 20px;
          }
        }
        .education {
          font-size: 14px;
          color: #8e8e8e;
          padding: 20px 0;
          span {
            margin-right: 20px;
          }
        }
        .achievement {
          font-size: 14px;
          color: #666;
          line-height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .expert-list {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 3200px;
          height: 61px;
          .list-item {
            float: left;
            width: 320px;
            height: 61px;

            .small-head {
              float: left;
              width: 61px;
              height: 61px;
            }
            .small-right {
              float: left;
              padding: 10px;
              font-size: 14px;
              color: #8b8b8b;
              p {
                width: 140px;
                padding: 2px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    .function-box {
      float: right;
      width: 295px;
      img {
        height: 124px;
        margin-bottom: 10px;
        cursor: pointer;
        &:nth-child(3) {
          margin: 0;
        }
      }
    }
  }
  .section6 {
    margin-top: 20px;
    .home-hotline {
      float: left;
      width: 272px;
      position: relative;
      .question {
        position: absolute;
        top: 215px;
        left: 50%;
        width: 183px;
        height: 45px;
        background-color: #08bc06;
        color: #fff;
        border-radius: 100px;
        text-align: center;
        line-height: 45px;
        margin-left: -91px;
      }
    }
    .problem-list {
      position: relative;
      float: left;
      padding: 15px 20px;
      background-color: #fff;
      width: calc(100% - 272px);
      height: 363px;
      .more {
        position: absolute;
        right: 20px;
        top: 25px;
        cursor: pointer;
        z-index: 2;
        font-size: 14px;
      }
      .problem-item:nth-child(2n-2) {
        margin-left: 88px;
      }
      .problem-item {
        float: left;
        width: 45%;
        margin-bottom: 20px;
        a {
          display: block;
          width: 100%;
          font-size: 18px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 24px;
          &:hover {
            color: #149508;
          }
        }
        p {
          font-size: 14px;
          color: #999;
          padding: 5px 0;
          .left {
            display: inline-block;
            width: 324px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue